module.exports = __webpack_public_path__ + "media/hyper/fonts/Nunito-SemiBold-26690929766633defdfdd531a3103eb2.svg";